import axios from 'axios'
import urlGenerator from './url-generator'
import { property } from 'lodash'
import createRequestConfig from './create-request-config'

const fetchData = () => axios.get(urlGenerator.requirements(), createRequestConfig()).then(property('data'))
export default fetchData